export default "__VITE_ASSET__mmGEXLPb__"